import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { AnnouncementBar } from "../components/layout/AnnouncementBar";
import { Header } from "../components/layout/Header";
import { Footer } from "../components/layout/Footer";
import { Hero } from "../components/home/Hero";
import { EditorialMarquee } from "../components/home/EditorialMarquee";
import { BraceletEdit } from "../components/home/BraceletEdit";
import { NewArrivals } from "../components/home/NewArrivals";
import { Bestsellers } from "../components/home/Bestsellers";
import { SignatureStack } from "../components/home/SignatureStack";
import { BuildYourStack } from "../components/home/BuildYourStack";
import { OurStory } from "../components/home/OurStory";
import { Newsletter } from "../components/home/Newsletter";
import { Seo, organizationLd } from "../components/Seo";
import { fetchProducts } from "../services/api";

const EDIT_CATEGORIES = ["everyday", "minimal", "statement", "festive"];
const EDIT_SORT = { everyday: "featured", minimal: "featured", statement: "price-desc", festive: "price-desc" };

export default function HomePage() {
  const [newest, setNewest] = useState([]);
  const [featured, setFeatured] = useState([]);
  const [bestsellers, setBestsellers] = useState([]);
  const [editProducts, setEditProducts] = useState({});
  const { hash } = useLocation();

  useEffect(() => {
    let active = true;
    const safe = (p) => p.catch(() => ({ items: [] }));
    safe(fetchProducts({ limit: 12, sort: "newest" })).then((res) => active && setNewest(res.items || []));
    safe(fetchProducts({ flags: "featured", limit: 12 })).then((res) => active && setFeatured(res.items || []));
    safe(fetchProducts({ flags: "bestseller", limit: 8 })).then((res) => active && setBestsellers(res.items || []));
    EDIT_CATEGORIES.forEach((cat) => {
      safe(fetchProducts({ category: cat, limit: 1, sort: EDIT_SORT[cat] })).then((res) => {
        if (active && res.items?.length) setEditProducts((prev) => ({ ...prev, [cat]: res.items[0] }));
      });
    });
    return () => {
      active = false;
    };
  }, []);

  useEffect(() => {
    if (!hash) return;
    const el = document.getElementById(hash.slice(1));
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  }, [hash, newest]);

  const favourites = bestsellers.length ? bestsellers : featured;

  return (
    <div className="min-h-screen bg-brand-cream font-sans text-brand-charcoal" data-testid="homepage">
      <Seo
        title="Bracelets for a Brighter You"
        description="Shop HESHAURA — a premium Indian bracelet-only brand. Everyday, minimal, charm, tennis, pearl and festive bracelets, hand-finished in small batches."
        path="/"
        jsonLd={organizationLd()}
      />
      <AnnouncementBar />
      <Header />
      <main>
        <Hero product={newest[0]} />
        <EditorialMarquee />
        <BraceletEdit editProducts={editProducts} />
        <Bestsellers products={favourites} />
        <SignatureStack products={featured} />
        <NewArrivals products={newest} />
        <BuildYourStack editProducts={editProducts} />
        <OurStory />
        <Newsletter />
      </main>
      <Footer />
    </div>
  );
}
